// extracted by mini-css-extract-plugin
export default {"item":"Sorter_item__XAHl2","footer":"Sorter_footer__MMEow","primary":"Sorter_primary__hnG7Q"};